import styled from "styled-components";
import { FlexContainers } from "../../../../components";

export const SelectDevicesStepWrapper = styled(FlexContainers.FlexColumnStart)`
  width: ${(props) => (props?.isGenerating ? "708px" : "1150px")};
  gap: 16px;
  padding: 10px 0;
`;
